import React from "react";
import { Box } from "@mui/material";
import CommonSelect from "../../../CommonComponents/Select/CommonSelect";
import VendorInputField from "./VendorInputField";
import VendorSelectField from "./VendorSelectField";
import SpecialisedField from "./SpecialisedField";
import styles from "../AddVendorModal.module.css";
import {
  basicVendorFields,
  lobOptions,
  motorCapacityField,
  motorSubProductOptions,
} from "../../../Utils/helper";

const VendorDetailsStep = ({
  vendorForm,
  formErrors,
  vendorSelectFields,
  subProductOptions,
  highValueOptions,
  isMotor,
  isHealth,
  locationLoadError,
  onChange,
  onStateChange,
  onLobChange,
  onSubProductChange,
  onHighValueChange,
  defaultSelectStyles,
}) => {
  const renderVendorInput = (field) => (
    <VendorInputField
      key={field.name}
      field={field}
      value={vendorForm[field.name]}
      error={formErrors[field.name]}
      onChange={onChange}
    />
  );

  return (
    <Box className={styles.vendorGrid}>
      {locationLoadError && (
        <Box className={styles.errorTextFullSpan}>{locationLoadError}</Box>
      )}

      {basicVendorFields.slice(0, 4).map(renderVendorInput)}

      {vendorSelectFields.map((field) => (
        <VendorSelectField
          key={field.name}
          field={field}
          value={vendorForm[field.name]}
          error={formErrors[field.name]}
          onChange={onChange}
          onStateChange={onStateChange}
        />
      ))}

      {basicVendorFields.slice(4).map(renderVendorInput)}

      <CommonSelect
        name="lob_id"
        label="LOB"
        value={vendorForm.lob_id}
        options={lobOptions}
        placeholder="Select LOB"
        required
        error={formErrors.lob_id}
        onChange={onLobChange}
        styles={defaultSelectStyles}
      />

      {isMotor && (
        <CommonSelect
          isMulti
          name="sub_product_id"
          label="Sub Product ID"
          value={vendorForm.sub_product_id}
          options={
            subProductOptions.length
              ? subProductOptions
              : motorSubProductOptions
          }
          placeholder="Select Sub Product ID"
          required
          error={formErrors.sub_product_id}
          onChange={onSubProductChange}
          styles={defaultSelectStyles}
        />
      )}

      {(isMotor || isHealth) && (
        <CommonSelect
          isMulti
          required
          name="high_value"
          label="High Value"
          value={vendorForm.high_value}
          options={highValueOptions}
          placeholder={
            isMotor && !vendorForm.sub_product_id.length
              ? "Select Sub Product first"
              : "Select High Value"
          }
          disabled={isMotor && !vendorForm.sub_product_id.length}
          error={formErrors.high_value}
          onChange={(event) => onHighValueChange(event, highValueOptions)}
          styles={defaultSelectStyles}
        />
      )}

      <SpecialisedField
        value={vendorForm.specialised}
        onChange={onChange}
        error={formErrors.specialised}
      />

      {isMotor && renderVendorInput(motorCapacityField)}
    </Box>
  );
};

export default VendorDetailsStep;
